import { Flex } from 'antd'
import * as ROUTES from 'src/constants/routes'
import { Link } from './link'

interface LinksProps {
  onLinkClick: () => void
}

const LINKS = [
  {
    label: 'Join',
    path: ROUTES.JOIN,
  },
  {
    label: 'FAQ',
    path: ROUTES.FAQ,
  },
  {
    label: 'Privacy Policy',
    path: ROUTES.PRIVACY_POLICY,
  },
  {
    label: 'Community Guidelines',
    path: ROUTES.COMMUNITY_GUIDELINES,
  },
]

export const Links = ({ onLinkClick }: LinksProps) => (
  <Flex vertical justify="center" align="start">
    {LINKS.map((link, index) => (
      <Link key={index} {...link} onClick={onLinkClick} />
    ))}
  </Flex>
)
